// Keep the next choice in view without moving keyboard focus or scrolling on data loads.
(() => {
  const dateSelector = '[data-component-pickup-date-select], [data-component-click-and-collect-delivery-date-select]'
  const connect = (root) => {
    if (root.dataset.guidedSelections) return
    root.dataset.guidedSelections = 'true'
    const controller = new AbortController()
    const signal = controller.signal
    root.disposeConfiguratorFlow = () => { controller.abort(); clearTimeout(timer); delete root.dataset.guidedSelections }
    let timer
    let lastGesture = -Infinity
    const addons = root.querySelector('product-addons-custom')
    const shipping = root.querySelector('[data-configurator-shipping-heading]')
    const nextFor = (control) => {
      if (control.closest('product-christmas-tree-stand-options-custom')) {
        const recycling = root.querySelector('product-collection-options-custom')
        return recycling?.getClientRects().length ? recycling : shipping
      }
      if (control.closest('product-collection-options-custom')) return shipping
      if (control.matches('input[type="radio"][data-variant-id], select.select__select')) return root.querySelector('product-christmas-tree-stand-options-custom')
      return null
    }
    const center = (target) => {
      if (!target) return
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (!target.getClientRects().length) return
        const rect = target.getBoundingClientRect()
        // Include the shipping choices, but not the entire expanded calendar.
        const height = target === shipping ? Math.min(300, innerHeight * 0.55) : rect.height
        const top = scrollY + rect.top - Math.max(96, (innerHeight - height) / 2)
        window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
      }, 180)
    }
    document.addEventListener('pointerdown', (event) => {
      if (event.isTrusted && (root.contains(event.target) || event.target.closest('.ss-content, .flatpickr-calendar'))) lastGesture = performance.now()
    }, { passive: true, capture: true, signal })
    document.addEventListener('keydown', (event) => {
      if (event.isTrusted && (root.contains(event.target) || event.target.closest('.ss-content, .flatpickr-calendar'))) lastGesture = performance.now()
    }, { capture: true, signal })
    root.addEventListener('change', (event) => {
      if (event.target.matches(dateSelector)) {
        if (event.target.value && addons && performance.now() - lastGesture < 1500) center(addons)
      } else if (performance.now() - lastGesture < 1500) {
        center(nextFor(event.target))
      }
    }, { capture: true, signal })
    // Opening Delivery or Click & Collect centres that tile (Jeremy 2026-10-20).
    // `toggle` doesn't bubble, so listen in the capture phase.
    root.addEventListener('toggle', (event) => {
      const details = /** @type {HTMLDetailsElement} */ (event.target)
      if (!details.matches?.('.pdoc__details, .pcc__details') || !details.open) return
      if (performance.now() - lastGesture < 1500) center(details)
    }, { capture: true, signal })
    // Once a shipping method is open, the other two dim but stay tappable
    // (Jeremy 2026-10-20). Delivery, Click & Collect and In store are each a
    // <details>; opening one closes the others.
    const shippingHosts = 'product-delivery-options-custom, product-click-and-collect-custom, in-store-accordion'
    const markUnchosen = () => {
      const open = root.querySelector('.pdoc__details[open], .pcc__details[open], .isa__details[open]')
      const chosen = open?.closest(shippingHosts)
      root.querySelectorAll(shippingHosts).forEach((host) => host.toggleAttribute('data-unchosen', Boolean(chosen) && host !== chosen))
    }
    root.addEventListener('toggle', (event) => {
      if (/** @type {HTMLElement} */ (event.target).matches?.('.pdoc__details, .pcc__details, .isa__details')) markUnchosen()
    }, { capture: true, signal })
    // A shopper can confirm the already-selected size or "No stand / No collection".
    document.addEventListener('click', (event) => {
      const label = event.target.closest('label[for]')
      if (label && root.contains(label)) {
        const input = document.getElementById(label.htmlFor)
        if (input && !input.disabled && !input.classList.contains('disabled')) center(nextFor(input))
      }
      // Stand tiles are buttons (2026-10-20): adding a stand or "No stand"
      // moves on to collection like the old stand dropdown did.
      const stand = event.target.closest('[data-stand-add], [data-stand-none]')
      if (stand && root.contains(stand) && !stand.disabled) center(nextFor(stand))
      const option = event.target.closest('.ss-option:not(.ss-disabled)')
      const id = option?.closest('.ss-content')?.dataset.id
      if (id) {
        const select = [...root.querySelectorAll('select[data-id]')].find((item) => item.dataset.id === id)
        if (select && !select.matches(dateSelector)) center(nextFor(select))
      }
    }, { capture: true, signal })
  }
  document.addEventListener('tte:configurator-ready', (event) => connect(event.target))
  document.querySelectorAll('variant-selects-custom').forEach(connect)
})()
